export default (function (_ref) {
  var colors = _ref.colors;
  return {
    select: {
      appearance: 'none',
      WebkitAppearance: 'none',
      height: '100%',
      width: '100%',
      padding: '20px 35px 3px 15px',
      backgroundColor: colors.white,
      border: 'none',
      color: colors.inputColor,
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '300',
      outline: 'none',
      transition: 'border-color .2s'
    },
    select__disabled: {
      cursor: 'not-allowed'
    },
    select__withIndicator: {
      paddingRight: '67px'
    },
    icon: {
      pointerEvents: 'none',
      position: 'absolute',
      height: '30px',
      paddingRight: '10px',
      paddingTop: '7px',
      top: '50%',
      transform: 'translateY(-50%)',
      right: 0,
      userSelect: 'none'
    },
    icon__withIndicator: {
      borderRight: "1px solid ".concat(colors.inputBorder),
      right: '32px'
    },
    selectIcon: {
      fill: colors.inputColor,
      width: '16px',
      height: '16px'
    }
  };
});